<template>
  <div class="wrap">
    <!--头部-->
    <myHead></myHead>

    <!--左侧-->
    <myNavbar></myNavbar>

    <!--右侧内容-->
    <myContent></myContent>

<!--    <router-link to="/ai/index" class="ai">-->
<!--      <img class="btn-ai" src="../assets/ai/gntb_aizs.png" alt="">-->
<!--    </router-link>-->

    <router-link v-if="$route.meta.showKq" to="/ai/attendance" class="ai">
      <img class="btn-ai2" src="../assets/ai/ai_rk_kqzs.png" alt="">
    </router-link>

    <div class="kf" :style="kfStyle">
      <img 
        @click="handleClick" 
        @mousedown="startDrag" 
        class="btn-kf" 
        src="../assets/img/fwan_lxkf.png" 
        alt=""
        :style="{ cursor: isDragging ? 'grabbing' : 'pointer' }"
      >
    </div>
  </div>
</template>

<script>
import myHead from "../components/Layout/Head";
import myNavbar from "../components/Layout/Navbar";
import myContent from "../components/Layout/Content";
export default {
  name: "App",
  components: { myHead, myNavbar, myContent },
  data() {
    return {
      kfStyle: {
        position: 'fixed',
        right: '30px',
        bottom: '90px',
        zIndex: 9
      },
      isDragging: false,
      isDraggingStarted: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      kfWidth: 62,
      kfHeight: 62,
      dragThreshold: 5
    };
  },
  mounted() {
    this.loadKfPosition();
    document.addEventListener('mousemove', this.onDrag);
    document.addEventListener('mouseup', this.endDrag);
  },
  beforeUnmount() {
    document.removeEventListener('mousemove', this.onDrag);
    document.removeEventListener('mouseup', this.endDrag);
  },
  methods: {
    getSupportUrl() {
      this.axios.get("/api/YYT3PC/Home/GetSupportUrl").then(res => {
       if(res.data.resultType == 0){
          window.open(res.data.appendData);
        }else{
         this.$message.warning(res.data.message)
       }
      })
    },
    loadKfPosition() {
      const saved = localStorage.getItem('kf_position');
      if (saved) {
        try {
          const pos = JSON.parse(saved);
          this.kfStyle.right = pos.right + 'px';
          this.kfStyle.bottom = pos.bottom + 'px';
        } catch (e) {
          console.error('加载客服位置失败:', e);
        }
      }
    },
    saveKfPosition() {
      const pos = {
        right: parseInt(this.kfStyle.right) || 30,
        bottom: parseInt(this.kfStyle.bottom) || 90
      };
      localStorage.setItem('kf_position', JSON.stringify(pos));
    },
    startDrag(e) {
      this.isDraggingStarted = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.offsetX = parseInt(this.kfStyle.right) || 30;
      this.offsetY = parseInt(this.kfStyle.bottom) || 90;
    },
    onDrag(e) {
      if (!this.isDraggingStarted) return;
      
      const deltaX = e.clientX - this.startX;
      const deltaY = e.clientY - this.startY;
      
      if (!this.isDragging) {
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        if (distance >= this.dragThreshold) {
          this.isDragging = true;
        }
      }
      
      if (this.isDragging) {
        let newRight = Math.max(10, window.innerWidth - e.clientX - this.kfWidth);
        let newBottom = Math.max(10, window.innerHeight - e.clientY);
        
        newRight = Math.min(newRight, window.innerWidth - this.kfWidth - 10);
        newBottom = Math.min(newBottom, window.innerHeight - this.kfHeight - 10);
        
        this.kfStyle.right = newRight + 'px';
        this.kfStyle.bottom = newBottom + 'px';
      }
    },
    endDrag() {
      if (this.isDragging) {
        this.saveKfPosition();
      }
      this.isDragging = false;
      this.isDraggingStarted = false;
    },
    handleClick() {
      if (!this.isDragging) {
        this.getSupportUrl();
      }
    }
  },
};
</script>

<style scoped>
.page_wrap {
  height: 100%;
  padding: 15px;
}
.page_wrap .page_left {
  float: left;
  width: calc(100% - 300px);
  min-width: 640px;
  min-height: 100%;
  background: #fff;
  border-radius: 6px;
  padding: 0 24px;
}
.page_wrap .page_left .top {
  margin-bottom: 30px;
}
.page_wrap .page_left .top .info .today {
  font-size: 18px;
  color: #3fbe3c;
  padding-left: 32px;
  background: url("../assets/images/ty_bt_rq.png") no-repeat;
  background-size: 32px 32px;
  background-position: 0 center;
  margin-bottom: 24px;
}
.page_wrap .page_left .top .details > ul {
  margin: 0 -10px;
}
.page_wrap .page_left .top .details > ul > li {
  padding: 0 10px;
  float: left;
  margin-bottom: 10px;
}
.page_wrap .page_left .top .details > ul > li .detail {
  width: 292px;
  height: 138px;
  border-radius: 11px;
  color: #fff;
  padding: 14px 20px 24px;
  margin: 0 auto;
}
.page_wrap .page_left .top .details > ul > li .detail .text {
  font-size: 20px;
  margin-bottom: 20px;
}
.page_wrap .page_left .top .details > ul > li .detail .total {
  text-align: right;
  font-size: 15px;
}
.page_wrap .page_left .top .details > ul > li .detail .total .count {
  font-size: 44px;
  font-weight: bold;
}
.page_wrap .page_left .top .details > ul > li.abnormal .detail {
  background: url("../assets/images/img_sy_bg1.png") no-repeat;
  background-size: 100% 100%;
}
.page_wrap .page_left .top .details > ul > li.leave .detail {
  background: url("../assets/images/img_sy_bg2.png") no-repeat;
  background-size: 100% 100%;
}
.page_wrap .page_left .top .details > ul > li.sick .detail {
  background: url("../assets/images/img_sy_bg3.png") no-repeat;
  background-size: 100% 100%;
}
.page_wrap .page_left .top .details > ul > li.medicine .detail {
  background: url("../assets/images/img_sy_bg4.png") no-repeat;
  background-size: 100% 100%;
}
.page_wrap .page_left .page_content .contentTop .right {
  float: right;
  font-size: 14px;
  color: #676c74;
  line-height: 48px;
  background: url("../assets/images/img_sy_Info.png") no-repeat;
  background-size: 16px 16px;
  background-position: 0 center;
  padding-left: 20px;
}
.page_wrap .page_left .page_content .tabItems {
  padding: 30px 0;
}
.page_wrap .page_left .page_content .tabItems .item .classItem {
  margin-bottom: 20px;
}
.page_wrap .page_left .page_content .tabItems .item .classItem .itemTitle {
  font-size: 16px;
  color: #191919;
  margin-bottom: 16px;
  padding-left: 38px;
  background: url("../assets/images/ty_bt_bj.png") no-repeat;
  background-size: 32px 32px;
  background-position: 0 center;
}

/*.page_wrap .page_right*/

@media screen and (min-width: 1166px) and (max-width: 1719px) {
  .details > ul > li .detail {
    padding: 0.16rem 20px 0.22rem !important;
    width: 2.92rem !important;
    height: 1.38rem !important;
  }
  .details > ul > li .detail .text {
    font-size: 16px !important;
    margin-bottom: 0.2rem !important;
  }
  .details > ul > li .detail .total {
    font-size: 15px !important;
  }
  .details > ul > li .detail .total .count {
    font-size: 0.44rem !important;
  }
}
@media screen and (max-width: 1239px) {
  .page_content .contentTop .tabs .tab {
    margin-right: 0 !important;
  }
}
@media screen and (max-width: 1079px) {
  .page_content .contentTop .tabs .tab {
    width: 80px !important;
    margin-right: 0 !important;
  }
  .page_content .contentTop .tabs .line {
    width: 80px !important;
  }
}
@media screen and (max-width: 1400px) {
  .itemInfo li {
    min-width: 80px;
    width: 1.8rem !important;
    padding: 24px 0 30px !important;
  }
  .itemInfo li .count {
    font-size: 32px;
    margin-bottom: 10px;
  }
  .itemInfo li .text {
    font-size: 15px;
  }
}
@media screen and (min-width: 1080px) and (max-width: 1399px) {
  .itemInfo li {
    width: 1.7rem !important;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1079px) {
  .itemInfo li {
    width: 1.6rem !important;
  }
}

.ai .btn-ai{
  width: 42px;
  height: 42px;
  position: fixed;
  right: 20px;
  bottom: 50px;
  z-index: 9;
}
.ai .btn-ai2{
  width: 72px;
  height: 88px;
  position: fixed;
  right: 20px;
  bottom: 50px;
  z-index: 9;
}


.kf .btn-kf{
  cursor: pointer;
  width: 62px;
  height: 62px;
}
/*# sourceMappingURL=../less/page_index.css.map */
</style>



// WEBPACK FOOTER //
// src/views/Home.vue